import ItemInfos from '@/src/interfaces/catalog/item-infos'
import React from 'react'
import styles from './styles.module.scss'
import { AnswerType } from '@/src/hooks/product/useWizard'

interface Props {
    itemOption: ItemInfos.ItemOption
    answerType: AnswerType
    isCombo: boolean
    isSelected: boolean
}

export default function AnswerTitleComponent(props: Props) {
    const itemOption = props.itemOption
    const answerType = props.answerType

    const renderTitle = (): JSX.Element => {
        let title: string = ''

        if (props.isCombo && (itemOption.itemChild?.sizes.length ?? 0) > 0)
            title = `${itemOption.itemChild?.sizes[0].sizeType.name} ${itemOption.itemChild?.name}`
        else if (itemOption.itemId)
            title = `${itemOption.itemChild?.name}`
        else
            title = `${itemOption.answerForCustomer}`

        const quantityItem = (answerType !== 'add' && itemOption.quantity > 1) ? `${itemOption.quantity}x ` : ''

        return (
            <p className={`font-xmd ${styles.answerTitle} ${props.isSelected ? styles.titleAnswered : ''}`}>
                {quantityItem}{title}
            </p>
        )
    }

    return renderTitle()
}
